(function () {
    const footerLink = document.currentScript.getAttribute('data-footer-link');
    var modal, btn, btn_footer, span, tabLinksWrapper, tabLinks;

    modal = document.querySelector("#sizeGuide");
    btn = document.querySelector("#sizeGuideLink");
    btn_footer = document.getElementById(footerLink);
    span = document.getElementsByClassName("close")[0];

    if (btn) {
        btn.onclick = function () {
            modal.style.display = "flex";
        }
        span.onclick = function () {
            modal.style.display = "none";
        }
        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }
    } else if (btn_footer) {
        btn_footer.onclick = function () {
            modal.style.display = "flex";
        }
        span.onclick = function () {
            modal.style.display = "none";
        }
        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
            }
        }
    }

    tabLinksWrapper = modal.querySelector('.tab-links');
    tabLinks = tabLinksWrapper.querySelectorAll('.tab-link');

    tabLinks.forEach(link => {
        if (link.getAttribute('data-default') == "true") {
            openGuideTab(link, link.getAttribute('data-tab'));
        }
        link.addEventListener('click', event => {
            openGuideTab(event.target, event.target.getAttribute('data-tab'));
        })
    })

    function openGuideTab(target, tab) {
        // Declare all variables
        var modal, tabContent, tabContentWrapper, tabLinksWrapper, tabLinks;

        modal = document.querySelector("#sizeGuide");
        tabLinksWrapper = modal.querySelector('.tab-links');
        tabContentWrapper = modal.querySelector('.tabcontent-wrapper');

        // Get all elements with class="tabcontent" and hide them
        tabContent = tabContentWrapper.querySelectorAll('.tabcontent');
        tabContent.forEach(tab => {
            tab.style.display = "none";
        });

        // Get all elements with class="tablinks" and remove the class "active"
        tabLinks = tabLinksWrapper.querySelectorAll('.tab-link');
        tabLinks.forEach(tab => {
            tab.classList.remove('tabActive');
        });

        // Show the current tab, and add an "active" class to the button that opened the tab
        tabContentWrapper.querySelector("#" + tab).style.display = 'block'
        target.classList.add('tabActive');
    }
})();